// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import displayProduct from "@awc/App/Handlers/BargainBin/DisplayProduct";
import {
    BargainBinProductsModel,
    BargainProductsApiParameter,
    getBargainBinProducts,
} from "@awc/App/Services/BargainBin";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    BargainProductsApiParameter & HasOnSuccess<BargainBinProductsModel> & HasOnError<string>,
    ServiceResult<BargainBinProductsModel>
>;

export const PopulateApiParameters: HandlerType = props => {
    const { onSuccess, onError, isBargainBinPage, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
    props.dispatch({
        type: "xBargain/LoadingBargains",
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBargainBinProducts(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "xBargain/completed",
            bargains: props.apiResult.result,
        } as any);
        if (props.parameter.isBargainBinPage) {
            // call getProductApi
            props.dispatch(
                displayProduct({
                    productId: props.parameter.productId,
                }));
        }
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnSuccessCallback];

const loadBargainBinProducts = createHandlerChainRunner(chain, "loadBargainBinProducts");

export default loadBargainBinProducts;
